import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useCursor } from "@/context/CursorContext";
import useMouse from "@react-hook/mouse-position";

const CustomCursor = ({ cursorRef }) => {
  const [cursorVisible, setCursorVisible] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [lastPosition, setLastPosition] = useState({ x: 0, y: 0 });

  const mouse = useMouse(cursorRef, {
    enterDelay: 100,
    leaveDelay: 100,
  });

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setCursorVisible(!isSmallScreen);
  }, [isSmallScreen]);

  // Aktualizuj ostatnią pozycję tylko jeśli mysz jest na ekranie
  useEffect(() => {
    if (mouse.clientX !== null && mouse.clientY !== null) {
      setLastPosition({ x: mouse.clientX, y: mouse.clientY });
    }
  }, [mouse.clientX, mouse.clientY]);

  const { cursorVariant, cursorText } = useCursor();

  const variants = {
    default: {
      opacity: cursorVisible ? 1 : 0,
      height: 10,
      width: 10,
      fontSize: "16px",
      backgroundColor: "#F0F0F0",
      mixBlendMode: "difference",
      x: mouse.clientX ?? lastPosition.x,
      y: mouse.clientY ?? lastPosition.y,
      transition: { type: "spring", stiffness: 150, damping: 15, mass: 0.1 },
    },
    project: {
      opacity: 1,
      backgroundColor: "#fafafa",
      color: "#1d2020",
      height: 80,
      width: 80,
      fontSize: "18px",
      x: (mouse.clientX ?? lastPosition.x) - 40,
      y: (mouse.clientY ?? lastPosition.y) - 40,
    },
    contact: {
      opacity: 1,
      backgroundColor: "#FFBCBC",
      height: 64,
      width: 64,
      fontSize: "32px",
      x: (mouse.clientX ?? lastPosition.x) - 32,
      y: (mouse.clientY ?? lastPosition.y) - 32,
    },
  };

  return (
    <AnimatePresence>
      {cursorVisible && (
        <motion.div
          variants={variants}
          className="circle text-background"
          animate={cursorVariant || "default"}
        >
          {cursorText && <span className="cursor-text">{cursorText}</span>}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CustomCursor;
